/**
 * Copyright (c) Miihe, Inc. and its affiliates.
 * Date:2021/1/17
 * Power By ZhangHebo
 */
import Vue from 'vue'
let self = new Vue();

export default {
	getBar(data,name,color,width,labelPos='top',options = {},barDw=''){
		if(color === 'green'){
			return this.getGreenBar(data,name,width,labelPos,options,barDw);
		}else if(color === 'blue'){
			return this.getBlueBar(data,name,width,labelPos,options,barDw);
		}else if(color === 'most'){
			return this.getColorBar(data,name,width,labelPos,options,barDw);
		}else if(color === 'orange'){
			return this.getOrangeBar(data,name,width,labelPos,options,barDw);
		}else if(color === 'red'){
			return this.getRedBar(data,name,width,labelPos,options,barDw)
		}else{
			return this.getBaseBar(data,name,width,labelPos,options,barDw)
		}
	},
	getBaseBar(data,name,width,labelPos = 'top',options = {}){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}',
				color:'#000',
			},
			barMaxWidth:width,
			...options
		};
		
		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getColorBar(data,name,width,labelPos='top',options = {},barDw=''){
		let _colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}'+barDw,
				color:'#000'
			},
			barMaxWidth:width,
			...options
		};

		if(data.length > 0){
			for(let i=0; i < data.length;i++){
				_bar.data.push({
					value: data[i],
					itemStyle: {
						color: _colors[i % _colors.length]
					}
				})
			}
		}
		
		// console.log(_bar)
		return _bar;
	},
	getGreenBar(data,name,width,labelPos = 'top',options = {},barDw=''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}'+barDw,
				color:'#000',
				textBorderColor:'rgba(255,255,255,.9)',
				textBorderWidth:4,
				textBorderType:'solid'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#B5EB45'
			}, {
				offset: 1,
				color: '#7ED321'
			}]),
			barMaxWidth:width,
			...options
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getBlueBar(data,name,width,labelPos = 'top',options = {},barDw=''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}'+barDw,
				color:'#000',
				textBorderColor:'rgba(255,255,255,.9)',
				textBorderWidth:4,
				textBorderType:'solid'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#00CCEF'
			}, {
				offset: 1,
				color: '#009DD9'
			}]),
			barMaxWidth:width,
			...options
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getOrangeBar(data,name,width,labelPos = 'top',options = {},barDw=''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}'+barDw,
				color:'#000',
				textBorderColor:'rgba(255,255,255,.9)',
				textBorderWidth:4,
				textBorderType:'solid'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#f1bc34'
			}, {
				offset: 1,
				color: '#ee880c'
			}]),
			barMaxWidth:width,
			...options
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getRedBar(data,name,width,labelPos = 'top',options = {},barDw=''){
		let _bar = {
			name: name,
			type: 'bar',
			data: [],
			label: {
				show: true,
				position: labelPos,
				formatter:'{c}'+barDw,
				color:'#000'
			},
			color:new self.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				offset: 0,
				color: '#f13470'
			}, {
				offset: 1,
				color: '#e0075e'
			}]),
			barMaxWidth:width,
			...options
		};

		if(data.length > 0){
			_bar.data = data;
		}
		return _bar;
	},
	getPurpleLine(data,name){
		let _line = {
			name: name,
			type: 'line',
			yAxisIndex: 1,
			data: [],
			color:'#651593',
			label: {
				show: true,
				position: 'top',
				formatter:'{c}%',
				color:'red',
				textBorderColor:'rgba(255,255,255,.9)',
				textBorderWidth:4,
				textBorderType:'solid'
			},
			smooth:true,
		};

		if(data.length > 0){
			_line.data = data;
		}
		return _line;
	},
	getRedLine(data,name){
		let _line = {
			name: name,
			type: 'line',
			yAxisIndex: 1,
			data: [],
			color:'#ba0a3c',
			label: {
				show: true,
				position: 'top',
				formatter:'{c}%',
				color:'#000',
				textBorderColor:'rgba(255,255,255,.9)',
				textBorderWidth:4,
				textBorderType:'solid'
			},
			smooth:true,
		};

		if(data.length > 0){
			_line.data = data;
		}
		return _line;
	},
	getLegend(data,pos = 'bottom',orient = 'horizontal'){

		let legend = {};

		if(data.length > 0){
			legend.data = [];
		}

		for(let i=0;i < data.length;i++){
			legend.data.push(data[i]);
		}

		if(pos === 'top'){
			legend.top = '0%';
		}else if(pos === 'left'){
			legend.left = '0%';
		}else if(pos === 'right'){
			legend.right = '0%';
			legend.top = 'middle';
		}else{
			legend.bottom = '0%';
		}

		legend.orient = orient


		return legend;
	},
}
